import { z } from 'zod';
import { validatedGet } from '../api-client.ts';

const PresentazioneConStatsSchema = z.object({
  id: z.number(),
  cassa: z.string(),
  dataPresentazione: z.string(),
  totale: z.number(),
  countConfermate: z.number(),
  countScartate: z.number(),
  countInAttesa: z.number(),
  esitoArrivato: z.boolean(),
  statiniJson: z.string().nullable(),
});

const PresentazioniListResult = z.object({
  presentazioni: z.array(PresentazioneConStatsSchema),
});

const PresentazioniAperteResult = z.object({ CE: z.boolean(), EC: z.boolean() });

export const presentazioniApi = {
  lista: () => validatedGet('presentazioni', PresentazioniListResult),

  aperte: (periodo: string) => validatedGet(`presentazioni/aperte?periodo=${periodo}`, PresentazioniAperteResult),

  csvUrl: (codaId: number) => `/api/presentazioni/${codaId}/csv`,
};
